import fileDownload from 'js-file-download';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3995/crear'
  : 'https://sideop-generador-word.daesaingenieria.com/crear';

export default {
  methods: {
    async mixGenerarPlantilla(data, nombreArchivo = 'plantilla-sideop') {
      await this.axios.post(
        BASE_URL,
        data,
        { responseType: 'blob' },
      )
        .then((res) => {
          if (res.data.type === 'text/plain') { fileDownload(res.data, `${nombreArchivo}_Error.txt`); } else {
            fileDownload(res.data, `${nombreArchivo}.docx`);
          }
        })
        .catch((err) => {
          this.mixMensajeError(err.statusText);
        });
    },
  },
};
